import { Button } from '@american-autonomy/ag-ui';

import CloseIcon from 'components/icons/CloseIcon';
import CaptionText from 'components/text/CaptionText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailsViewCloseButton: FunctionComponent<Props> = ({
    className = '',
    onClick,
    testId = TEST_ID
}) => {
    const { ESC } = useTranslation();

    return (
        <Button
            className={`${styles.detailsViewCloseButton} ${className}`}
            onClick={onClick}
            testId={testId}>
            <CloseIcon className={styles.closeIcon} />

            <CaptionText className={styles.captionText}>{ESC}</CaptionText>
        </Button>
    );
};

export default DetailsViewCloseButton;
